import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://esl-ready.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Get the ESL READY™ Pack',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group mt-2.5 inline-flex items-center justify-center gap-3 rounded-full bg-brand px-[35px] py-7 text-center text-sm font-extrabold uppercase leading-none text-white shadow-soft transition-all duration-200 hover:-translate-y-0.5 hover:bg-brand-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:text-base ${className}`} data-id="element-43" data-mp="qkaf71fqsvrs">
      <span className="-mr-[0.12em] tracking-[0.12em]" data-id="element-44" data-mp="159q5kgbd2z6y">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-45" data-mp="157dendnmlehr" />
    </a>;
}